import { type RouteRecordRaw } from 'vue-router'

import { useUsersStore } from './users.store'

export const UsersRouter: RouteRecordRaw[] = [
  {
    path: '/users',
    component: async () => import('./Users.vue'),
  },
  {
    path: '/users/create',
    component: async () => import('./AddUser.vue'),
    beforeEnter() {
      // A user left in edition (e.g. browser back) must not turn the
      // creation into an update of that user
      useUsersStore.getState().reset()
    },
  },
  {
    path: '/users/:id',
    component: async () => import('./AddUser.vue'),
    async beforeEnter(to) {
      await useUsersStore.getState().loadUser(to.params.id as string)
    },
  },
]
